import React from "react";
import { Link } from "react-router-dom";
import PriceTag from "./PriceTag";

function isWithin30Days(dateStr) {
  if (!dateStr) return false;
  return (Date.now() - new Date(dateStr).getTime()) < 30 * 24 * 60 * 60 * 1000;
}

export default function ProductCard({ p }) {
  const img1 = p.images?.[0];
  const img2 = p.images?.[1] || img1;
  const isSoldOut = (p.stock || 0) <= 0;
  const isNew = !isSoldOut && isWithin30Days(p.created_at);
  const isRestock = !isSoldOut && isWithin30Days(p.restocked_at);
  return (
    <Link to={`/product/${p.slug}`} className="product-card relative block group" data-testid={`product-card-${p.slug}`}>
      <div className="relative w-full aspect-[4/5] bg-[#111] overflow-hidden">
        <img src={img1} alt={p.name} className={`primary w-full h-full object-cover img-zoom ${isSoldOut ? "opacity-70" : ""}`} />
        <img src={img2} alt={p.name} className="secondary" />
        {isRestock && (
          <span className="sticker absolute top-3 left-3 text-white border-white bg-[#111]" data-testid={`card-restock-${p.slug}`}>↑ RESTOCK</span>
        )}
        {!isRestock && isNew && (
          <span className="sticker absolute top-3 left-3 text-[#CFF048] border-[#CFF048]" data-testid={`card-new-${p.slug}`}>★ NEW</span>
        )}
        {isSoldOut && (
          <span className="sticker absolute top-3 left-3 text-[#CFF048] border-[#CFF048] bg-black" data-testid={`card-soldout-${p.slug}`}>SOLD OUT</span>
        )}
        <span className="sticker absolute top-3 right-3">{p.collection?.toUpperCase()}</span>
      </div>
      <div className="p-4 border-t border-[#27272A]">
        <h3 className="font-display font-bold text-sm md:text-base leading-tight line-clamp-2">{p.name}</h3>
        <p className="label-mono text-[#71717A] mt-1">{p.sizes?.length} sizes // {p.colors?.length} colorways</p>
        <div className="mt-2"><PriceTag price={p.price} mrp={p.mrp} size="sm" /></div>
      </div>
    </Link>
  );
}
